import React from 'react'


export function Botao(props) {
    let attrModal = {}

    if (props.fecharModal) {
        attrModal = { 'data-dismiss': 'modal' }
    }
    return (
        <button type={(!props.submit ? "button" : "submit")} onClick={() => { if ((props.onClick) && (!props.readOnly)) { props.onClick(props.parametro) } }}
            className={`btn${(props.preencher ? ' btn-block' : '')} bg-gradient-${props.cor}${(props.readOnly ? ' disabled' : '')}${(props.classe ? ' ' + props.classe : '')}`}
            {...attrModal}>
            {(props.icone ? (<i className={`fas fa-${props.icone}`}></i>) : '')}{(props.label ? ' ' + props.label : '')}
        </button>
    )
}